import { MessageSquareText } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Stars } from "@/components/recording/Stars";
import { RecordingPlayer } from "@/components/recording/RecordingPlayer";
import { fmt } from "@/components/recording/useRecorder";

export const MyRecordings = ({ items }) => {
  const { t } = useLang();
  return (
    <div data-testid="my-recordings">
      <p className="text-xs font-bold mb-2">{t.rec.mine}</p>
      {!items.length && <p className="text-xs opacity-80" data-testid="my-recordings-empty">{t.rec.none}</p>}
      <ul className="space-y-2 max-h-32 sm:max-h-48 overflow-y-auto" data-lenis-prevent>
        {items.map((x) => (
          <li key={x.id} className="bg-white/70 border border-black/10 rounded-sm p-3 text-[#1C1917]" data-testid={`my-recording-${x.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="text-xs text-stone-700">{new Date(x.created_at).toLocaleString()} · {fmt(x.duration)}</span>
              {x.rating ? <Stars value={x.rating} testId={`my-recording-stars-${x.id}`} /> : <span className="text-xs text-amber-800 font-semibold" data-testid={`my-recording-awaiting-${x.id}`}>{t.rec.awaiting}</span>}
            </div>
            <div className="mt-2"><RecordingPlayer id={x.id} /></div>
            {x.feedback && (
              <p className="mt-2 text-sm flex gap-1.5 items-start border-s-2 border-[#047857] ps-2" dir="auto" data-testid={`my-recording-feedback-${x.id}`}>
                <MessageSquareText className="w-4 h-4 shrink-0 mt-0.5 text-[#047857]" /> <span><b>{t.rec.teacherNote}:</b> {x.feedback}</span>
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
